import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

class StructureTypologyApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see StructureTypologyApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'typology', 'StructureTypology');
    }
    /**
     * Servicio encargado de obtener la estructuras de tipología activa
     * @returns Retorna un array de tipo @see StructureTypologyDto con la información de los registros
     * @example
     * // Get all records by channel and state
     * this.service.getStructureByState(1, true).suscribe(x => console.log(x))
     */
    getStructureActive() {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetStructureActive`));
    }
}
StructureTypologyApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StructureTypologyApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
StructureTypologyApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StructureTypologyApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StructureTypologyApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

class TypeTypologyApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see TypeTypologyApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'typology', 'TypeTypology');
    }
}
TypeTypologyApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeTypologyApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
TypeTypologyApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeTypologyApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeTypologyApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

class TypeAttendeeApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see TypeAttendeeApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'typology', 'TypeAttendee');
    }
}
TypeAttendeeApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeAttendeeApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
TypeAttendeeApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeAttendeeApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TypeAttendeeApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/**
 * Servicio
 */
class StatesRequestDAApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see StatesRequestDAApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'typology', 'StatesRequestDA');
    }
}
StatesRequestDAApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StatesRequestDAApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
StatesRequestDAApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StatesRequestDAApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StatesRequestDAApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of typology
 */

/**
 * Generated bundle index. Do not edit.
 */

export { StatesRequestDAApiService, StructureTypologyApiService, TypeAttendeeApiService, TypeTypologyApiService };
